import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Services.css";
import ServiceBanner from "../components/ServiceBanner";
import ServicesCard from "../components/ServicesCard";





function Services() {

  return (
    <>


      <Navbar />
      <ServiceBanner />


      <div className="services-heading">
        <h2>Our Core Services</h2>
      </div>

      <ServicesCard />


      {/* ICONS */}
      <div className="floating-buttons">

        <a href="https://wa.me/918624968686" className="float-btn">
          <i className="fa-brands fa-whatsapp"></i>
        </a>

        <a href="tel:+918624968686" className="float-btn">
          <i className="fa-solid fa-phone"></i>
        </a>

        <a href="/contact" className="talk-btn">
          <i className="fa-solid fa-phone"></i>
          Talk to Klyzen
        </a>

      </div>



      <Footer />

    </>
  )
}
export default Services;



